module.exports = __webpack_public_path__ + "static/favicon-2f00d27627cc4917cdbbb8acf35c199e.png";